
import Graphs from './containers/Graphs';

export default Graphs;
